import { render, staticRenderFns } from "./FormCreateApproval.vue?vue&type=template&id=2a540c24&"
import script from "./FormCreateApproval.vue?vue&type=script&lang=ts&"
export * from "./FormCreateApproval.vue?vue&type=script&lang=ts&"
import style0 from "./FormCreateApproval.vue?vue&type=style&index=0&id=2a540c24&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports